<template>
  <div class="empty-content-container">
    <div class="empty-content-center-wrp">
      <div
        class="empty-content-center-image"
        :style="{ width: widthImg, height: heightImg }"
      >
        <img
          class="w-100 h-100"
          :src="image"
          alt=""
          draggable="false"
        >
      </div>
      <div
        class="empty-title empty-content-center-title font-f3 font-large-1 mt-2"
      >
        {{ title }}
      </div>
      <div class="empty-content-center-desc font-f2 font-medium-5 mt-1">
        {{ description }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: { type: String, default: '' },
    widthImg: { type: String, default: '88px' },
    heightImg: { type: String, default: '88px' },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
  },
}
</script>

<style scoped>
.empty-content-container {
  width: 100%;
  height: calc(100% - var(--header-bar-content));
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}

.empty-title {
  color: #a7b1c6;
}

.empty-content-center-image {
  margin: auto;
}

.empty-content-center-title {
  text-align: center;
}

.empty-content-center-desc {
  text-align: center;
}
</style>
